const r = localStorage.getItem("r");
const winner_token = localStorage.getItem("winner_token");
const params = new URLSearchParams();
if (r) params.append("r", r);
if (winner_token) params.append("winner_token", winner_token);

const handleNavigation = (
  surveyStatus?: string,
  hasStore?: boolean,
  canRevise?: boolean,
  luckyDrawStatus?: any
) => {
  if (luckyDrawStatus === "claimed") {
    return "/processing";
  }
  if (hasStore) {
    if (canRevise) return "/store";
    switch (surveyStatus) {
      case "draft":
      case "answered":
      case "responded":
      case "paid":
        return "/store";

      default:
        return `/skincaresteps${
          params.toString() ? "?" + params.toString() : ""
        }`;
    }
  } else {
    switch (surveyStatus) {
      case "paid":
      case "answered":
        return "/processing";

      case "responded":
        return "/store";

      default:
        if (r) {
          return `/skincaresteps?r=${r}`;
        }
        if (winner_token) {
          return `/skincaresteps?winner_token=${winner_token}`;
        }
        return `/skincaresteps${params.toString() ? "?" + params.toString() : ""}`;
    }
  }
};

export default handleNavigation;
